<template>
  <div class="body">
    <v-header :headerClassName="headerClassName"></v-header>
    <div class="banner">
      <img :src="tempBgPath" alt />
      <span class="btn" @click="goRegistered"></span>
      <span class="btn1" @click="goRegistered"></span>
    </div>
    <div class="paper-body-index">
      <div class="download-content">
        <div class="notice">
          <p class="font-gray">
            游客用户提交下载后，仅为您保留文件<em>48</em>小时，请尽快下载。
          </p>
          <p class="font-gray">
            注册成为淘个图官网用户，享受VIP价：1.5元/张，充值限时赠送,<em
              >低至0.75元/张!</em
            >
            （先到先得，<a @click="goRegistered">马上注册</a>）
          </p>
          <div class="text-list">
            <p>
              <span class="circle"></span>
              <countdown
                v-if="this.info.isFlag"
                :currentTime="Number(info.currentTime)"
                :startTime="Number(info.startDate)"
                :endTime="Number(info.endDate)"
                :tipText="'下载开始倒计时'"
                :tipTextEnd="'下载结束倒计时'"
                :endText="'次卡使用已过期'"
                :dayTxt="'天'"
                :hourTxt="'时'"
                :minutesTxt="'分'"
                :secondsTxt="'秒'"
              ></countdown>
              <span v-else>未开始下载计时</span>
            </p>
            <p>
              <span class="circle"></span>
              <span :class="timecount == 0 ? 'font-gray' : null"
                >剩余下载次数: {{ timecount }} 次</span
              >
            </p>
            <p>
              <span class="circle"></span>
              <span
                >hi22开头10位数编号ID无法下载（例：hi2236071928），如有需要请联系上方的微信客服咨询价格。</span
              >
            </p>
          </div>
          <!-- <div class="arrow" @click="goRegistered">
            <img
              src="@/assets/images/activity/rightPop11.png"
              style="transform:scale(1.5)"
              alt=""
            />
          </div> -->
        </div>
        <Content
          v-for="(item, index) in list"
          :key="index"
          v-if="index == current"
          :tabContent="item"
          :intimes="timecount"
          :isSearching="isSearching"
          @search="searchId"
        />
        <Table
          :data="tableDatas"
          :sureflag="isSureDownload"
          :downflag="isDownloading"
          :clearflag="isClearFlag"
          v-if="showTable"
          v-loading="tableLoading"
          @changeTime="changeTimes"
          @noBanlance="noBanlances"
          @onDownload="downloadId"
          @onSureDown="changeDown"
        />
        <el-tabs v-model="currentValue" class="tabs-list" v-show="isShow">
          <el-tab-pane
            v-for="(o, oIndex) in tabList"
            :key="oIndex"
            :label="o.label"
            :name="o.name"
            class="tabs-content"
            v-loading="tableLoading1"
          >
            <downlists
              :obj="o.data"
              @sizeChange="sizeChange"
              @pageChange="pageChange"
            />
          </el-tab-pane>
        </el-tabs>
        <div class="qrCode">
          <p>通过微信联系我们</p>
          <img src="@/assets/images/code.png" alt />
          <p class="font-red">扫一扫关注官方微信公众号</p>
        </div>
      </div>
    </div>
    <Dialog
      :dialogVisible="dialogTableVisible"
      @closeDialog="closeConstDetailPop"
    />
  </div>
</template>

<script>
import header from "@/components/header/header.vue";
import countdown from "@/components/tempcount/countdown.vue";
import Table from "./module/table.vue";
import downlists from "./module/downlists.vue";
import Content from "./module/content.vue";
import Dialog from "./module/dialog.vue";
import { tempLogin, searchImage } from "../../api/downLoad";
import { message } from "@/utils/resetMessage";
import { setTempUser, setToken } from "../../utils/storage";
import { getConsumeList } from "../../api/order";
import { MessageBox } from "element-ui";
export default {
  components: {
    "v-header": header,
    Table,
    Content,
    Dialog,
    countdown,
    downlists,
  },
  props: ["tempToken"],
  data() {
    return {
      isClearFlag: false,
      isShow: false,
      isSearching: false,
      searchCount: 0,
      isDownloading: false,
      isTip: "",
      headerClassName: "fixed-index header-opacity",
      current: 0,
      webType: "shutterstock",
      list: [
        {
          title: "【S/H下载区】",
          subTitle: "",
          titleState: "success",
          label: "",
        },
      ],
      tableDatas: [],
      showTable: false, //是否显示表格
      tableLoading: false, //加载数据效果
      dialogTableVisible: false, //费用明细弹窗
      isSureDownload: false,
      form: {
        webType: "",
        imageID: "",
      },
      token: this.tempToken,
      bannerList: [
        "24 hours",
        "自助下载系统 全新上线",
        "七大素材网站 合而为一 24小时下载服务",
      ],
      timecount: 0, //剩余次数
      time: 48, //图片保留时间
      dataForm: {
        img: "", //缩略图
        id: "", //图片ID
        imgSize: "", //图片大小
        complete: false, //操作状态为按钮
        loading: false, //操作状态为加载
        saleType: "", //默认为空
        price: 0, //图片价格
        balance: "", //用户余额
        value: 4, //图片类型默认值
        disabled: true, //是否可选
        options: [], //图片类型
        webType: this.webType, //网站类型
        downurl: "", //主下载链接
        downurl2: "", //备用下载链接
        type: true, //搜索ID是否正常
        msg: "", //提示消息
        error: false, //下载错误状态
      },
      info: {
        currentTime: "",
        startDate: "",
        endDate: "",
        isFlag: false, //是否显示
      },
      currentValue: "first",
      tabList: [
        {
          label: "下载历史",
          name: "first",
          data: {},
        },
      ],
      tableLoading1: false,
      pageNo: 1,
      pageSize: 10,
      currentItem: "",
      tempBgPath: require("@/assets/images/temp_bg.jpeg"),
    };
  },
  created() {
    //进入次卡页面先清空
    this.$store.commit("loginNameType", null);
    this.$store.dispatch("setUserInfo", null);
    this.$store.commit("token", null);
    this.$store.commit("updateShowAdvert", false);
    this.$store.commit("updateShowPost", false);
    setToken("");
    setTempUser("");
  },
  mounted() {
    //进入次卡页面先清空
    this.$store.commit("loginNameType", null);
    this.$store.dispatch("setUserInfo", null);
    this.$store.commit("token", null);
    this.$store.commit("updateShowAdvert", false);
    this.$store.commit("updateShowPost", false);
    setToken("");
    setTempUser("");
    this.checkToken();
  },
  methods: {
    checkToken() {
      let dataform = {
        token: this.token,
      };
      tempLogin(dataform)
        .then((result) => {
          if (result.flag) {
            //成功
            this.isShow = true;
            this.$store.commit("token", result.token);
            setToken(result.token);
            setTempUser("temp");
            this.timecount = result.times;
            //初始化次卡
            this.getTableLists();
            if (result.status == 0) {
              this.info.currentTime = new Date();
              this.info.startDate = result.flyTempAccountInfo.lastDownloadTime;
              this.info.endDate = result.date;
              this.info.isFlag = true;
            } else {
              this.info.isFlag = false;
            }
          } else {
            this.isShow = false;
            MessageBox.confirm("该次卡已过期或无效,谢谢", "系统提示", {
              confirmButtonText: "知道了",
              showCancelButton: false,
              type: "warning",
            }).then(() => {});
          }
        })
        .catch((error) => {
          //休息1s 后再执行一次
          setTimeout(() => {
            tempLogin(dataform)
              .then((result) => {
                if (result.flag) {
                  //成功
                  this.isShow = true;
                  this.$store.commit("token", result.token);
                  setToken(result.token);
                  setTempUser("temp");
                  this.timecount = result.times;
                  //初始化次卡
                  this.getTableLists();
                  if (result.status == 0) {
                    this.info.currentTime = new Date();
                    this.info.startDate =
                      result.flyTempAccountInfo.lastDownloadTime;
                    this.info.endDate = result.date;
                    this.info.isFlag = true;
                  } else {
                    this.info.isFlag = false;
                  }
                } else {
                  this.isShow = false;
                  MessageBox.confirm("该次卡已过期或无效,谢谢", "系统提示", {
                    confirmButtonText: "知道了",
                    showCancelButton: false,
                    type: "warning",
                  }).then(() => {});
                }
              })
              .catch((error) => {
                MessageBox.confirm(
                  "由于网络原因，页面加载异常，是否尝试刷新？",
                  "系统提示",
                  {
                    confirmButtonText: "点击刷新",
                    cancelButtonText: "取消",
                    type: "warning",
                  }
                ).then(() => {
                  this.$router.go(0);
                });
              });
          }, 1000);
        });
    },
    getTableLists() {
      this.tableLoading1 = true;
      this.tabList.forEach((item, index) => {
        let dataform = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          orderType: index + 1,
        };
        getConsumeList(dataform)
          .then((result) => {
            this.tableLoading1 = false;
            if (result.datalists != null) {
              result.datalists.forEach((item1) => {
                if (item1.source == 1) {
                  if (item1.icon.indexOf("img.pptuku.com") > -1) {
                    item1.tempUrl = item1.icon.replace(
                      "img.pptuku.com",
                      "img.tukuwu.com"
                    );
                  } else if (item1.icon.indexOf("img.taogetu.com") > -1) {
                    item1.tempUrl = item1.icon.replace(
                      "img.taogetu.com",
                      "img.tukuwu.com"
                    );
                  } else {
                    item1.tempUrl = item1.icon.replace(
                      "img.taogetu.com",
                      "img.tukuwu.com"
                    );
                  }
                  item1.icon =
                    "https://img.aatuku.com/preview260/" +
                    item1.recCode +
                    ".jpg";
                }
              });
            }
            item.data = result;
          })
          .catch((error) => {
            getConsumeList(dataform)
              .then((result) => {
                this.tableLoading1 = false;
                if (result.datalists != null) {
                  result.datalists.forEach((item1) => {
                    if (item1.source == 1) {
                      if (item1.icon.indexOf("img.pptuku.com") > -1) {
                        item1.tempUrl = item1.icon.replace(
                          "img.pptuku.com",
                          "img.tukuwu.com"
                        );
                      } else {
                        item1.tempUrl = item1.icon.replace(
                          "img.taogetu.com",
                          "img.tukuwu.com"
                        );
                      }
                      item1.icon =
                        "https://img.pptuku.com/preview260/" +
                        item1.recCode +
                        ".jpg";
                    }
                  });
                }
                item.data = result;
              })
              .catch((error) => {
                message.error({
                  message: "网络加载异常，请刷新",
                  duration: 4000,
                  offset: 80,
                });
                this.tableLoading1 = false;
              });
          });
      });
    },
    pageChange(params) {
      this.pageNo = params;
      this.pageSize = 10;
      this.getTableLists();
    },
    sizeChange(param) {
      this.pageSize = param;
      this.pageNo = 1;
      this.getTableLists();
    },
    //切换tab
    changeTab(index) {
      this.current = index;
    },
    //费用明细
    openConstDetailPop() {
      this.dialogTableVisible = true;
    },
    closeConstDetailPop() {
      this.dialogTableVisible = false;
    },
    //获取表格数据
    getTableDatas(result) {
      //请求成功后赋值，并且去掉加载效果
      this.dataForm = {
        img: "", //缩略图
        id: "", //图片ID
        imgSize: "", //图片大小
        complete: false, //操作状态为按钮
        loading: false, //操作状态为加载
        saleType: "", //默认为空
        price: 0, //图片价格
        balance: "", //用户余额
        value: 4, //图片类型默认值
        disabled: true, //是否可选
        options: [], //图片类型
        webType: this.webType, //网站类型
        downurl: "", //主下载链接
        downurl2: "", //备用下载链接
        downurl3: "", //海外下载链接
        type: true, //正常
        msg: "", //提示消息
        isCos: false, //是否腾讯云
        showType: true, //是否显示类型
        isBuy: false, //是否购买过
        error: false, //下载错误状态
        isDownload: false, //是否在下载
        isDownload1: false, //是否在备用下载
        errorIcon: "", //飞鸟链接
        isOffset: false, //高级图
      };
      //请求成功后赋值，并且去掉加载效果
      if (result.status == 0) {
        this.dataForm.id = result.recCode;
        this.dataForm.isOffset =
          result.searchDTO.is_loaded == "2" ? true : false;
        if (this.dataForm.isOffset) {
          this.dataForm.msg =
            "啊哦⊙∀⊙！这些图片编号ID好像错误了，或者图片已被下架...";
          this.dataForm.type = false;
        } else {
          this.dataForm.price = result.price;
          this.dataForm.isCos = result.detailJson[0].isCos;
          //设置是否购买
          this.dataForm.isBuy = result.detailJson[0].isBuy;
          if (result.iconUrl != null && result.iconUrl != "") {
            //this.dataForm.img = result.iconUrl.replace("image.shutterstock.com","img.pptuku.com");
            this.dataForm.img =
              "https://img.aatuku.com/preview260/" + result.recCode + ".jpg";
            this.dataForm.errorIcon = result.iconUrl.replace(
              "image.shutterstock.com",
              "img.tukuwu.com"
            );
          }
          if (this.dataForm.isBuy) {
            this.dataForm.msg = "免费";
          }
          if (result.searchDTO.picType == 0) {
            //0为jpg
            this.dataForm.imgSize = result.detailJson[0].px;
            this.dataForm.value = 0;
            this.dataForm.options = [{ value: 0, label: "JPG" }];
          } else {
            //4为eps
            this.dataForm.value = 4;
            this.dataForm.options = [{ value: 4, label: "EPS" }];
          }
        }
      } else {
        this.dataForm.id = result.recCode;
        this.dataForm.msg = result.msg;
        this.dataForm.type = false;
      }
      this.tableDatas.push(this.dataForm);
      this.tableLoading = false;
    },
    getTableDatas223(imageID) {
      //请求成功后赋值，并且去掉加载效果
      this.dataForm = {
        img: "", //缩略图
        id: imageID, //图片ID
        imgSize: "", //图片大小
        complete: false, //操作状态为按钮
        loading: false, //操作状态为加载
        saleType: "", //默认为空
        price: 0, //图片价格
        balance: "", //用户余额
        value: 4, //图片类型默认值
        disabled: true, //是否可选
        options: [], //图片类型
        webType: this.webType, //网站类型
        downurl: "", //主下载链接
        downurl2: "", //备用下载链接
        downurl3: "", //海外下载链接
        type: false, //正常
        msg: "hi22开头编号由于特殊原因，请联系上方客服咨询下载，非普通价格 ", //提示消息
        isCos: false, //是否腾讯云
        showType: true, //是否显示类型
        isBuy: false, //是否购买过
        error: false, //下载错误状态
        isDownload: false, //是否在下载
        isDownload1: false, //是否在备用下载
      };

      this.tableDatas.push(this.dataForm);
      this.tableLoading = false;
    },
    //下载ID
    downloadId(flag) {
      this.isSearching = flag;
      this.isDownloading = flag;
    },
    //改变下载状态
    changeDown(flag) {
      this.isSureDownload = flag;
    },
    //搜索
    async searchId(prams) {
      this.isSearching = true;
      this.isDownloading = true;
      this.isSureDownload = false;
      this.tableDatas = [];
      this.showTable = true;
      this.tableDatas.length > 0
        ? (this.tableLoading = false)
        : (this.tableLoading = true);
      this.tableLoading = true;

      //根据余额限制搜索数量
      if (prams.length > this.timecount) {
        //限制一次最多搜索timecount个
        message.error({
          message: "一次性最多只能搜索" + this.timecount + "个ID",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        this.downloadId(false);
        this.showTable = false;
        this.tableLoading = false; //加载数据效果
        return;
      } else {
        // 不超出不做限制
      }
      var len = 0;
      while (len < prams.length) {
        let dataform = {
          webType: this.webType,
          imageID: prams[len],
        };
        //判断是否223  10位
        if (
          dataform.imageID.startsWith("hi22") &&
          (dataform.webType == "shutterstock" ||
            dataform.webType == "shutterstock_V2")
        ) {
          this.getTableDatas223(dataform.imageID);
        } else {
          try {
            let res = await searchImage(dataform);
            if (res.recCode != null && res.recCode != "") {
              this.getTableDatas(res);
            } else {
              let res = await searchImage(dataform);
              if (res.recCode != null && res.recCode != "") {
                this.getTableDatas(res);
              } else {
                message.error({
                  message: "网络异常，请重试",
                  showClose: true,
                  duration: 4000,
                  offset: 100,
                });
              }
            }
          } catch {
            message.error({
              message: "网络异常，请重试",
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
        }
        this.tableDatas.length > 0
          ? (this.tableLoading = false)
          : (this.tableLoading = true);
        len++;
        if (len == 1) {
          this.$EventBus.$emit("move", "1");
        }
      }
      this.isSearching = false;
      this.isDownloading = false;
      this.isClearFlag = false;
      this.tableLoading = false;
    },
    //购买结束
    changeTimes(prams) {
      this.timecount = prams;
    },
    noBanlances() {
      //余额不足
      this.tableDatas = [];
      this.isSureDownload = false;
    },
    goBack() {
      location.reload();
    },
    //马上体验
    goLogin() {
      let routeUrl = this.$router.resolve({ path: "/login" });
      window.open(routeUrl.href, "_self");
    },
    //马上注册
    goRegistered() {
      let routeUrl = this.$router.resolve({ path: "/registered" });
      window.open(routeUrl.href, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/tempdownload.scss";
</style>
